import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { getProductList } from '../api/ventura/kpiProduct';
import { useConfig } from './useConfig';

function useKpiProducts(keyword: string, defaultPage = 0, defaultPerPage = 9999) {
  const { apiHost } = useConfig();
  const [page, setPage] = useState(defaultPage);
  const [perPage, setPerPage] = useState(defaultPerPage);

  const adGroups = useQuery({
    queryKey: ['kpiProducts', keyword, page, perPage],
    queryFn: () => getProductList(apiHost, keyword, { page, perPage }),
    enabled: !!keyword,
  });
  return { page, setPage, perPage, setPerPage, ...adGroups };
}

export default useKpiProducts;
